module.exports = __webpack_public_path__ + "img/16.8bde70b8.jpg";